import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPleskComponent } from './simple-icons-plesk.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPleskComponent ],
    exports:      [ SimpleIconsPleskComponent ],
    bootstrap:    []
})
export class SimpleIconsPleskModule {}
